/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * Entrypoint for plain website. This file is loaded on all pages.
 */
import "@devowl-wp/utils"; // Import once for startup polyfilling (e. g. setimmediate)

import { delegateClickThroughUnblockedContent, listenOptInForContentBlocker, listenOptInJqueryFnForContentBlocker } from "./others";
import { listenDecideToUnblockTcf } from "./tcf";
import { ready } from "./utils";
delegateClickThroughUnblockedContent();
listenOptInForContentBlocker();
listenOptInJqueryFnForContentBlocker(["mediaelementplayer"]);

if (process.env.IS_TCF === "1") {
  listenDecideToUnblockTcf();
}

ready(function () {
  listenOptInJqueryFnForContentBlocker(["fitVids"]);
});